module.exports = "//static.hsappstatic.net/ecosystem-marketplace-core/static-1.5496/img/callout-blobs.svg"